/**
 * JS-зеркало src/styles/breakpoints.css. Значения обязаны совпадать.
 */
export const BREAKPOINTS = {
  /** Мобильная раскладка: нижняя навигация, шиты вместо поповеров. */
  mobile: 760,
  /** Планшет: рельса библиотеки → сегменты, полка фильтров → шит. */
  tablet: 860,
  /** Сетка каталога: 4 → 3 колонки. */
  narrowGrid: 1100,
  /** Сетка каталога: 5 колонок. */
  wide: 1500,
  /** Сетка каталога: 6 колонок. */
  ultra: 1900,
} as const;

export const mediaQuery = {
  mobile: `(max-width: ${BREAKPOINTS.mobile}px)`,
  tablet: `(max-width: ${BREAKPOINTS.tablet}px)`,
  narrowGrid: `(max-width: ${BREAKPOINTS.narrowGrid}px)`,
  wide: `(min-width: ${BREAKPOINTS.wide}px)`,
  ultra: `(min-width: ${BREAKPOINTS.ultra}px)`,
  hoverOk: '(hover: hover)',
  hoverNone: '(hover: none)',
  reducedMotion: '(prefers-reduced-motion: reduce)',
  prefersLight: '(prefers-color-scheme: light)',
} as const;
